import { detail } from './detail';

export const homes = {
    routeTitle: 'Homes',
    route: 'Homes',
    listOfHomes: 'List of homes',
    addHome: 'Add home',
    editHome: 'Edit home',
    invitationSuccesfullySent: 'Invitation succesfully sent.',
    addHomeResident: 'Invite new resident',
    processingInvitationLink: 'Processing invitation link, please wait...',
    wrongUserInvitation1:
        'Error while trying to accept the invitation. Maybe the invitation was already accepted, or you are connected with the wrong user. You are currently connected as ',
    wrongUserInvitation2:
        ". Please verify the invitation's email, then if necessary login with the right user and try again.",
    acceptInvitationSuccess: 'Invitation accepted',
    name: 'Name',
    postalCode: 'ZIP Code',
    owner: 'Owner',
    sureToDeleteContent: 'Deleted home name is: ',
    sureToUndeleteContent: 'Undeleted home name is: ',
    euroPerKwhBuy: 'Price per kWh purchase',
    euroPerKwhSell: 'Price per kWh sell',
    kgco2PerKwh: 'kgCO2 per kWh',
    capacity: 'Capacity (kWp / kWh)',
    installationDate: 'Installation Date',
    kwLimit: 'Maximum grid kW limit used for OCPP_Gateway Charging',
    kwhEuro: 'Eur/kWh',
    switchesInstalled: 'Switches installed',
    unlimited: 'Unlimited',
    switchInstallationNotAllowed:
        'New switch installation is not allowed. Please upgrade your cloud plan',
    switchList: 'Switch list',
    addSwitch: 'Add new switch',
    priority: 'Prio',
    readyAt: 'Ready at',
    offFrom: 'Off from',
    offTo: 'To',
    assignedDevice: 'Device',
    assignedPhase: 'Phase',
    usageThresholdAlert: 'Power usage',
    alwaysOnAlert: 'Always on',
    dataMissingAlert: 'Data missing',
    next: 'Next >',
    back: '< Back',
    finish: 'Finish',
    switchModel: 'Model',
    switchName: 'Name',
    switchIotAddress: 'IoT hub/SmartPi address',
    switchSSID: 'Local Wifi SSID',
    switchWifiPassword: 'Local Wifi password',
    switchInstallationStep2:
        "Turn off your mobile data, plug your Switch and connect your phone wifi to it's SSID similar to 'shelly-' and press 'Next'",
    switchInstallationStep3:
        "Connect your phone to the Internet and press 'Next'",
    switchInstallationStep4:
        'Your switch is configured successfully. Please attach a device to it and make it usable. You will see the configuration form in next step.',
    editRelay: 'Edit Relay',
    editSwitch: 'Edit Switch',
    relayMode: 'Mode',
    relayDevice: 'Device',
    relayPhase: 'Phase',
    relayPriority: 'Priority',
    relayReadyAt: 'Ready at',
    relayOffFrom: 'Switch off from',
    relayOffTo: 'Switch off to',
    deleteSwitch: 'Delete switch',
    confirmDeleteSwitch: 'Are you sure you want to delete this switch?',
    reconfig: 'Reconfigure',
    modbusId: 'Modbus Id',
    ski: 'SKI',
    detail
};